/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,4],$V1=[1,7],$V2=[1,5],$V3=[1,9],$V4=[1,6],$V5=[2,6],$V6=[1,16],$V7=[6,8,14,20,22,24,25,27,29,32,35,39,49,53],$V8=[8,14,20,22,24,25,27,29,32,35,39],$V9=[8,13,14,20,22,24,25,27,29,32,35,39],$Va=[1,26],$Vb=[6,8,14,49,53],$Vc=[8,14,53],$Vd=[1,64],$Ve=[1,65],$Vf=[1,66],$Vg=[8,14,33,38,41,53];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"start":3,"eol":4,"directive":5,"GG":6,"document":7,"EOF":8,":":9,"DIR":10,"options":11,"body":12,"OPT":13,"NL":14,"line":15,"statement":16,"commitStatement":17,"mergeStatement":18,"cherryPickStatement":19,"acc_title":20,"acc_title_value":21,"acc_descr":22,"acc_descr_value":23,"acc_descr_multiline_value":24,"section":25,"branchStatement":26,"CHECKOUT":27,"ID":28,"BRANCH":29,"ORDER":30,"NUM":31,"CHERRY_PICK":32,"COMMIT_ID":33,"STR":34,"MERGE":35,"COMMIT_TYPE":36,"commitType":37,"COMMIT_TAG":38,"COMMIT":39,"commit_arg":40,"COMMIT_MSG":41,"NORMAL":42,"REVERSE":43,"HIGHLIGHT":44,"openDirective":45,"typeDirective":46,"closeDirective":47,"argDirective":48,"open_directive":49,"type_directive":50,"arg_directive":51,"close_directive":52,";":53,"$accept":0,"$end":1},
terminals_: {2:"error",6:"GG",8:"EOF",9:":",10:"DIR",13:"OPT",14:"NL",20:"acc_title",21:"acc_title_value",22:"acc_descr",23:"acc_descr_value",24:"acc_descr_multiline_value",25:"section",27:"CHECKOUT",28:"ID",29:"BRANCH",30:"ORDER",31:"NUM",32:"CHERRY_PICK",33:"COMMIT_ID",34:"STR",35:"MERGE",36:"COMMIT_TYPE",38:"COMMIT_TAG",39:"COMMIT",41:"COMMIT_MSG",42:"NORMAL",43:"REVERSE",44:"HIGHLIGHT",49:"open_directive",50:"type_directive",51:"arg_directive",52:"close_directive",53:";"},
productions_: [0,[3,2],[3,2],[3,3],[3,4],[3,5],[7,0],[7,2],[11,2],[11,1],[12,0],[12,2],[15,2],[15,1],[16,1],[16,1],[16,1],[16,2],[16,2],[16,1],[16,1],[16,1],[16,2],[26,2],[26,4],[19,3],[18,2],[18,4],[18,4],[18,4],[18,6],[18,6],[18,6],[18,6],[18,6],[18,6],[18,8],[18,8],[18,8],[18,8],[18,8],[18,8],[17,2],[17,3],[17,3],[17,5],[17,5],[17,3],[17,5],[17,5],[17,5],[17,5],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,3],[17,5],[17,5],[17,5],[17,5],[17,5],[17,5],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[17,9],[40,0],[40,1],[37,1],[37,1],[37,1],[5,3],[5,5],[45,1],[46,1],[48,1],[47,1],[4,1],[4,1],[4,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 3:
 return $$[$0]; 
break;
case 4:
 return $$[$0-1]; 
break;
case 5:
yy.setDirection($$[$0-3]); return $$[$0-1];
break;
case 7:
 yy.setOptions($$[$0-1]); this.$ = $$[$0]
break;
case 8:
$$[$0-1] +=$$[$0]; this.$=$$[$0-1]
break;
case 10:
this.$ = []
break;
case 11:
$$[$0-1].push($$[$0]); this.$=$$[$0-1];
break;
case 12:
this.$ =$$[$0-1]
break;
case 17:
 this.$=$$[$0].trim();yy.setAccTitle(this.$); 
break;
case 18: case 19:
 this.$=$$[$0].trim();yy.setAccDescription(this.$); 
break;
case 20:
yy.addSection($$[$0].substr(8));this.$=$$[$0].substr(8);
break;
case 22:
yy.checkout($$[$0])
break;
case 23:
yy.branch($$[$0])
break;
case 24:
yy.branch($$[$0-2], $$[$0])
break;
case 25:
yy.cherryPick($$[$0])
break;
case 26:
yy.merge($$[$0],'','','')
break;
case 27:
yy.merge($$[$0-2], $$[$0],'','')
break;
case 28:
yy.merge($$[$0-2],'', $$[$0],'')
break;
case 29:
yy.merge($$[$0-2], '','',$$[$0])
break;
case 30:
yy.merge($$[$0-4], $$[$0],'', $$[$0-2])
break;
case 31:
yy.merge($$[$0-4], '',$$[$0], $$[$0-2])
break;
case 32:
yy.merge($$[$0-4], '',$$[$0-2], $$[$0])
break;
case 33:
yy.merge($$[$0-4], $$[$0-2], $$[$0], '')
break;
case 34:
yy.merge($$[$0-4], $$[$0-2], '', $$[$0])
break;
case 35:
yy.merge($$[$0-4], $$[$0],$$[$0-2], '')
break;
case 36:
yy.merge($$[$0-6], $$[$0-4], $$[$0-2], $$[$0])
break;
case 37:
yy.merge($$[$0-6], $$[$0], $$[$0-4], $$[$0-2])
break;
case 38:
yy.merge($$[$0-6], $$[$0-4], $$[$0], $$[$0-2])
break;
case 39:
yy.merge($$[$0-6], $$[$0-2], $$[$0-4], $$[$0])
break;
case 40:
yy.merge($$[$0-6], $$[$0], $$[$0-2], $$[$0-4])
break;
case 41:
yy.merge($$[$0-6], $$[$0-2], $$[$0], $$[$0-4])
break;
case 42:
yy.commit($$[$0])
break;
case 43:
yy.commit('','',yy.commitType.NORMAL,$$[$0])
break;
case 44:
yy.commit('','',$$[$0],'')
break;
case 45:
yy.commit('','',$$[$0],$$[$0-2])
break;
case 46:
yy.commit('','',$$[$0-2],$$[$0])
break;
case 47:
yy.commit('',$$[$0],yy.commitType.NORMAL,'')
break;
case 48:
yy.commit('',$$[$0-2],yy.commitType.NORMAL,$$[$0])
break;
case 49:
yy.commit('',$$[$0],yy.commitType.NORMAL,$$[$0-2])
break;
case 50:
yy.commit('',$$[$0-2],$$[$0],'')
break;
case 51:
yy.commit('',$$[$0],$$[$0-2],'')
break;
case 52:
yy.commit('',$$[$0-4],$$[$0-2],$$[$0])
break;
case 53:
yy.commit('',$$[$0-4],$$[$0],$$[$0-2])
break;
case 54:
yy.commit('',$$[$0-2],$$[$0-4],$$[$0])
break;
case 55:
yy.commit('',$$[$0],$$[$0-4],$$[$0-2])
break;
case 56:
yy.commit('',$$[$0],$$[$0-2],$$[$0-4])
break;
case 57:
yy.commit('',$$[$0-2],$$[$0],$$[$0-4])
break;
case 58:
yy.commit($$[$0],'',yy.commitType.NORMAL,'')
break;
case 59:
yy.commit($$[$0],'',yy.commitType.NORMAL,$$[$0-2])
break;
case 60:
yy.commit($$[$0-2],'',yy.commitType.NORMAL,$$[$0])
break;
case 61:
yy.commit($$[$0-2],'',$$[$0],'')
break;
case 62:
yy.commit($$[$0],'',$$[$0-2],'')
break;
case 63:
yy.commit($$[$0],$$[$0-2],yy.commitType.NORMAL,'')
break;
case 64:
yy.commit($$[$0-2],$$[$0],yy.commitType.NORMAL,'')
break;
case 65:
yy.commit($$[$0-4],'',$$[$0-2],$$[$0])
break;
case 66:
yy.commit($$[$0-4],'',$$[$0],$$[$0-2])
break;
case 67:
yy.commit($$[$0-2],'',$$[$0-4],$$[$0])
break;
case 68:
yy.commit($$[$0],'',$$[$0-4],$$[$0-2])
break;
case 69:
yy.commit($$[$0],'',$$[$0-2],$$[$0-4])
break;
case 70:
yy.commit($$[$0-2],'',$$[$0],$$[$0-4])
break;
case 71:
yy.commit($$[$0-4],$$[$0],$$[$0-2],'')
break;
case 72:
yy.commit($$[$0-4],$$[$0-2],$$[$0],'')
break;
case 73:
yy.commit($$[$0-2],$$[$0],$$[$0-4],'')
break;
case 74:
yy.commit($$[$0],$$[$0-2],$$[$0-4],'')
break;
case 75:
yy.commit($$[$0],$$[$0-4],$$[$0-2],'')
break;
case 76:
yy.commit($$[$0-2],$$[$0-4],$$[$0],'')
break;
case 77:
yy.commit($$[$0-4],$$[$0],yy.commitType.NORMAL,$$[$0-2])
break;
case 78:
yy.commit($$[$0-4],$$[$0-2],yy.commitType.NORMAL,$$[$0])
break;
case 79:
yy.commit($$[$0-2],$$[$0],yy.commitType.NORMAL,$$[$0-4])
break;
case 80:
yy.commit($$[$0],$$[$0-2],yy.commitType.NORMAL,$$[$0-4])
break;
case 81:
yy.commit($$[$0],$$[$0-4],yy.commitType.NORMAL,$$[$0-2])
break;
case 82:
yy.commit($$[$0-2],$$[$0-4],yy.commitType.NORMAL,$$[$0])
break;
case 83:
yy.commit($$[$0-6],$$[$0-4],$$[$0-2],$$[$0])
break;
case 84:
yy.commit($$[$0-6],$$[$0-4],$$[$0],$$[$0-2])
break;
case 85:
yy.commit($$[$0-6],$$[$0-2],$$[$0-4],$$[$0])
break;
case 86:
yy.commit($$[$0-6],$$[$0],$$[$0-4],$$[$0-2])
break;
case 87:
yy.commit($$[$0-6],$$[$0-2],$$[$0],$$[$0-4])
break;
case 88:
yy.commit($$[$0-6],$$[$0],$$[$0-2],$$[$0-4])
break;
case 89:
yy.commit($$[$0-4],$$[$0-6],$$[$0-2],$$[$0])
break;
case 90:
yy.commit($$[$0-4],$$[$0-6],$$[$0],$$[$0-2])
break;
case 91:
yy.commit($$[$0-2],$$[$0-6],$$[$0-4],$$[$0])
break;
case 92:
yy.commit($$[$0],$$[$0-6],$$[$0-4],$$[$0-2])
break;
case 93:
yy.commit($$[$0-2],$$[$0-6],$$[$0],$$[$0-4])
break;
case 94:
yy.commit($$[$0],$$[$0-6],$$[$0-2],$$[$0-4])
break;
case 95:
yy.commit($$[$0],$$[$0-4],$$[$0-2],$$[$0-6])
break;
case 96:
yy.commit($$[$0-2],$$[$0-4],$$[$0],$$[$0-6])
break;
case 97:
yy.commit($$[$0],$$[$0-2],$$[$0-4],$$[$0-6])
break;
case 98:
yy.commit($$[$0-2],$$[$0],$$[$0-4],$$[$0-6])
break;
case 99:
yy.commit($$[$0-4],$$[$0-2],$$[$0],$$[$0-6])
break;
case 100:
yy.commit($$[$0-4],$$[$0],$$[$0-2],$$[$0-6])
break;
case 101:
yy.commit($$[$0-2],$$[$0-4],$$[$0-6],$$[$0])
break;
case 102:
yy.commit($$[$0],$$[$0-4],$$[$0-6],$$[$0-2])
break;
case 103:
yy.commit($$[$0-2],$$[$0],$$[$0-6],$$[$0-4])
break;
case 104:
yy.commit($$[$0],$$[$0-2],$$[$0-6],$$[$0-4])
break;
case 105:
yy.commit($$[$0-4],$$[$0-2],$$[$0-6],$$[$0])
break;
case 106:
yy.commit($$[$0-4],$$[$0],$$[$0-6],$$[$0-2])
break;
case 107:
this.$ = ""
break;
case 108:
this.$=$$[$0]
break;
case 109:
 this.$=yy.commitType.NORMAL;
break;
case 110:
 this.$=yy.commitType.REVERSE;
break;
case 111:
 this.$=yy.commitType.HIGHLIGHT;
break;
case 114:
 yy.parseDirective('%%{', 'open_directive'); 
break;
case 115:
 yy.parseDirective($$[$0], 'type_directive'); 
break;
case 116:
 $$[$0] = $$[$0].trim().replace(/'/g, '"'); yy.parseDirective($$[$0], 'arg_directive'); 
break;
case 117:
 yy.parseDirective('}%%', 'close_directive', 'gitGraph'); 
break;
}
},
table: [{3:1,4:2,5:3,6:$V0,8:$V1,14:$V2,45:8,49:$V3,53:$V4},{1:[3]},{3:10,4:2,5:3,6:$V0,8:$V1,14:$V2,45:8,49:$V3,53:$V4},{3:11,4:2,5:3,6:$V0,8:$V1,14:$V2,45:8,49:$V3,53:$V4},{7:12,8:$V5,9:[1,13],10:[1,14],11:15,14:$V6},o($V7,[2,118]),o($V7,[2,119]),o($V7,[2,120]),{46:17,50:[1,18]},{50:[2,114]},{1:[2,1]},{1:[2,2]},{8:[1,19]},{7:20,8:$V5,11:15,14:$V6},{9:[1,21]},o($V8,[2,10],{12:22,13:[1,23]}),o($V9,[2,9]),{9:[1,25],47:24,52:$Va},o([9,52],[2,115]),{1:[2,3]},{8:[1,27]},{7:28,8:$V5,11:15,14:$V6},{8:[2,7],14:[1,31],15:29,16:30,17:32,18:33,19:34,20:[1,35],22:[1,36],24:[1,37],25:[1,38],26:39,27:[1,40],29:[1,44],32:[1,43],35:[1,42],39:[1,41]},o($V9,[2,8]),o($Vb,[2,112]),{48:45,51:[1,46]},o($Vb,[2,117]),{1:[2,4]},{8:[1,47]},o($V8,[2,11]),{4:48,8:$V1,14:$V2,53:$V4},o($V8,[2,13]),o($Vc,[2,14]),o($Vc,[2,15]),o($Vc,[2,16]),{21:[1,49]},{23:[1,50]},o($Vc,[2,19]),o($Vc,[2,20]),o($Vc,[2,21]),{28:[1,51]},o($Vc,[2,107],{40:52,33:[1,55],34:[1,57],36:[1,54],38:[1,53],41:[1,56]}),{28:[1,58]},{33:[1,59]},{28:[1,60]},{47:61,52:$Va},{52:[2,116]},{1:[2,5]},o($V8,[2,12]),o($Vc,[2,17]),o($Vc,[2,18]),o($Vc,[2,22]),o($Vc,[2,42]),{34:[1,62]},{37:63,42:$Vd,43:$Ve,44:$Vf},{34:[1,67]},{34:[1,68]},o($Vc,[2,108]),o($Vc,[2,26],{33:[1,69],36:[1,70],38:[1,71]}),{34:[1,72]},o($Vc,[2,23],{30:[1,73]}),o($Vb,[2,113]),o($Vc,[2,43],{33:[1,75],36:[1,74],41:[1,76]}),o($Vc,[2,44],{33:[1,78],38:[1,77],41:[1,79]}),o($Vg,[2,109]),o($Vg,[2,110]),o($Vg,[2,111]),o($Vc,[2,47],{36:[1,81],38:[1,80],41:[1,82]}),o($Vc,[2,58],{33:[1,85],36:[1,84],38:[1,83]}),{34:[1,86]},{37:87,42:$Vd,43:$Ve,44:$Vf},{34:[1,88]},o($Vc,[2,25]),{31:[1,89]},{37:90,42:$Vd,43:$Ve,44:$Vf},{34:[1,91]},{34:[1,92]},{34:[1,93]},{34:[1,94]},{34:[1,95]},{34:[1,96]},{37:97,42:$Vd,43:$Ve,44:$Vf},{34:[1,98]},{34:[1,99]},{37:100,42:$Vd,43:$Ve,44:$Vf},{34:[1,101]},o($Vc,[2,27],{36:[1,102],38:[1,103]}),o($Vc,[2,28],{33:[1,105],38:[1,104]}),o($Vc,[2,29],{33:[1,106],36:[1,107]}),o($Vc,[2,24]),o($Vc,[2,45],{33:[1,108],41:[1,109]}),o($Vc,[2,49],{36:[1,110],41:[1,111]}),o($Vc,[2,59],{33:[1,113],36:[1,112]}),o($Vc,[2,46],{33:[1,114],41:[1,115]}),o($Vc,[2,51],{38:[1,116],41:[1,117]}),o($Vc,[2,62],{33:[1,119],38:[1,118]}),o($Vc,[2,48],{36:[1,120],41:[1,121]}),o($Vc,[2,50],{38:[1,122],41:[1,123]}),o($Vc,[2,63],{36:[1,124],38:[1,125]}),o($Vc,[2,60],{33:[1,127],36:[1,126]}),o($Vc,[2,61],{33:[1,129],38:[1,128]}),o($Vc,[2,64],{36:[1,130],38:[1,131]}),{37:132,42:$Vd,43:$Ve,44:$Vf},{34:[1,133]},{34:[1,134]},{34:[1,135]},{34:[1,136]},{37:137,42:$Vd,43:$Ve,44:$Vf},{34:[1,138]},{34:[1,139]},{37:140,42:$Vd,43:$Ve,44:$Vf},{34:[1,141]},{37:142,42:$Vd,43:$Ve,44:$Vf},{34:[1,143]},{34:[1,144]},{34:[1,145]},{34:[1,146]},{34:[1,147]},{34:[1,148]},{34:[1,149]},{37:150,42:$Vd,43:$Ve,44:$Vf},{34:[1,151]},{34:[1,152]},{34:[1,153]},{37:154,42:$Vd,43:$Ve,44:$Vf},{34:[1,155]},{37:156,42:$Vd,43:$Ve,44:$Vf},{34:[1,157]},{34:[1,158]},{34:[1,159]},{37:160,42:$Vd,43:$Ve,44:$Vf},{34:[1,161]},o($Vc,[2,33],{38:[1,162]}),o($Vc,[2,34],{36:[1,163]}),o($Vc,[2,32],{33:[1,164]}),o($Vc,[2,35],{38:[1,165]}),o($Vc,[2,30],{36:[1,166]}),o($Vc,[2,31],{33:[1,167]}),o($Vc,[2,56],{41:[1,168]}),o($Vc,[2,69],{33:[1,169]}),o($Vc,[2,57],{41:[1,170]}),o($Vc,[2,80],{36:[1,171]}),o($Vc,[2,70],{33:[1,172]}),o($Vc,[2,79],{36:[1,173]}),o($Vc,[2,55],{41:[1,174]}),o($Vc,[2,68],{33:[1,175]}),o($Vc,[2,54],{41:[1,176]}),o($Vc,[2,74],{38:[1,177]}),o($Vc,[2,67],{33:[1,178]}),o($Vc,[2,73],{38:[1,179]}),o($Vc,[2,53],{41:[1,180]}),o($Vc,[2,81],{36:[1,181]}),o($Vc,[2,52],{41:[1,182]}),o($Vc,[2,75],{38:[1,183]}),o($Vc,[2,76],{38:[1,184]}),o($Vc,[2,82],{36:[1,185]}),o($Vc,[2,66],{33:[1,186]}),o($Vc,[2,77],{36:[1,187]}),o($Vc,[2,65],{33:[1,188]}),o($Vc,[2,71],{38:[1,189]}),o($Vc,[2,72],{38:[1,190]}),o($Vc,[2,78],{36:[1,191]}),{34:[1,192]},{37:193,42:$Vd,43:$Ve,44:$Vf},{34:[1,194]},{34:[1,195]},{37:196,42:$Vd,43:$Ve,44:$Vf},{34:[1,197]},{34:[1,198]},{34:[1,199]},{34:[1,200]},{37:201,42:$Vd,43:$Ve,44:$Vf},{34:[1,202]},{37:203,42:$Vd,43:$Ve,44:$Vf},{34:[1,204]},{34:[1,205]},{34:[1,206]},{34:[1,207]},{34:[1,208]},{34:[1,209]},{34:[1,210]},{37:211,42:$Vd,43:$Ve,44:$Vf},{34:[1,212]},{34:[1,213]},{34:[1,214]},{37:215,42:$Vd,43:$Ve,44:$Vf},{34:[1,216]},{37:217,42:$Vd,43:$Ve,44:$Vf},{34:[1,218]},{34:[1,219]},{34:[1,220]},{37:221,42:$Vd,43:$Ve,44:$Vf},o($Vc,[2,36]),o($Vc,[2,38]),o($Vc,[2,37]),o($Vc,[2,39]),o($Vc,[2,41]),o($Vc,[2,40]),o($Vc,[2,97]),o($Vc,[2,98]),o($Vc,[2,95]),o($Vc,[2,96]),o($Vc,[2,100]),o($Vc,[2,99]),o($Vc,[2,104]),o($Vc,[2,103]),o($Vc,[2,102]),o($Vc,[2,101]),o($Vc,[2,106]),o($Vc,[2,105]),o($Vc,[2,94]),o($Vc,[2,93]),o($Vc,[2,92]),o($Vc,[2,91]),o($Vc,[2,89]),o($Vc,[2,90]),o($Vc,[2,88]),o($Vc,[2,87]),o($Vc,[2,86]),o($Vc,[2,85]),o($Vc,[2,83]),o($Vc,[2,84])],
defaultActions: {9:[2,114],10:[2,1],11:[2,2],19:[2,3],27:[2,4],46:[2,116],47:[2,5]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
            function lex() {
            var token;
            token = tstack.pop() || lexer.lex() || EOF;
            if (typeof token !== 'number') {
                if (token instanceof Array) {
                    tstack = token;
                    token = tstack.pop();
                }
                token = self.symbols_[token] || token;
            }
            return token;
        }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var errStr = '';
            expected = [];
            for (p in table[state]) {
                if (this.terminals_[p] && p > TERROR) {
                    expected.push('\'' + this.terminals_[p] + '\'');
                }
            }
            if (lexer.showPosition) {
                errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
            } else {
                errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
            }
            this.parseError(errStr, {
                text: lexer.match,
                token: this.terminals_[symbol] || symbol,
                line: lexer.yylineno,
                loc: yyloc,
                expected: expected
            });
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: this.begin('open_directive'); return 49; 
break;
case 1: this.begin('type_directive'); return 50; 
break;
case 2: this.popState(); this.begin('arg_directive'); return 9; 
break;
case 3: this.popState(); this.popState(); return 52; 
break;
case 4:return 51;
break;
case 5: this.begin("acc_title");return 20; 
break;
case 6: this.popState(); return "acc_title_value"; 
break;
case 7: this.begin("acc_descr");return 22; 
break;
case 8: this.popState(); return "acc_descr_value"; 
break;
case 9: this.begin("acc_descr_multiline");
break;
case 10: this.popState(); 
break;
case 11:return "acc_descr_multiline_value";
break;
case 12:/*{console.log('New line');return 14;}*/ return 14;
break;
case 13:/* skip all whitespace */
break;
case 14:/* skip comments */
break;
case 15:/* skip comments */
break;
case 16:return 6;
break;
case 17:return 39;
break;
case 18:return 33;
break;
case 19:return 36;
break;
case 20:return 41;
break;
case 21:return 42;
break;
case 22:return 43;
break;
case 23:return 44;
break;
case 24:return 38;
break;
case 25:return 29;
break;
case 26:return 30;
break;
case 27:return 35;
break;
case 28:return 32;
break;
case 29:return 27;
break;
case 30:return 10;
break;
case 31:return 10;
break;
case 32:return 9;
break;
case 33:return 'CARET'
break;
case 34:this.begin("options"); //
break;
case 35:this.popState();       // not used anymore in the renderer, fixed for backward compatibility
break;
case 36:return 13;          //
break;
case 37:this.begin("string");
break;
case 38:this.popState();
break;
case 39:return 34;
break;
case 40:return 31;
break;
case 41:return 28;
break;
case 42:return 8;
break;
}
},
rules: [/^(?:%%\{)/i,/^(?:((?:(?!\}%%)[^:.])*))/i,/^(?::)/i,/^(?:\}%%)/i,/^(?:((?:(?!\}%%).|\n)*))/i,/^(?:accTitle\s*:\s*)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accDescr\s*:\s*)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accDescr\s*\{\s*)/i,/^(?:[\}])/i,/^(?:[^\}]*)/i,/^(?:(\r?\n)+)/i,/^(?:\s+)/i,/^(?:#[^\n]*)/i,/^(?:%[^\n]*)/i,/^(?:gitGraph\b)/i,/^(?:commit\b)/i,/^(?:id:)/i,/^(?:type:)/i,/^(?:msg:)/i,/^(?:NORMAL\b)/i,/^(?:REVERSE\b)/i,/^(?:HIGHLIGHT\b)/i,/^(?:tag:)/i,/^(?:branch\b)/i,/^(?:order:)/i,/^(?:merge\b)/i,/^(?:cherry-pick\b)/i,/^(?:checkout\b)/i,/^(?:LR\b)/i,/^(?:BT\b)/i,/^(?::)/i,/^(?:\^)/i,/^(?:options\r?\n)/i,/^(?:[ \r\n\t]+end\b)/i,/^(?:[\s\S]+(?=[ \r\n\t]+end))/i,/^(?:["])/i,/^(?:["])/i,/^(?:[^"]*)/i,/^(?:[0-9]+)/i,/^(?:[a-zA-Z][-_\./a-zA-Z0-9]*[-_a-zA-Z0-9])/i,/^(?:$)/i],
conditions: {"acc_descr_multiline":{"rules":[10,11],"inclusive":false},"acc_descr":{"rules":[8],"inclusive":false},"acc_title":{"rules":[6],"inclusive":false},"close_directive":{"rules":[],"inclusive":false},"arg_directive":{"rules":[3,4],"inclusive":false},"type_directive":{"rules":[2,3],"inclusive":false},"open_directive":{"rules":[1],"inclusive":false},"options":{"rules":[35,36],"inclusive":false},"string":{"rules":[38,39],"inclusive":false},"INITIAL":{"rules":[0,5,7,9,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,37,40,41,42],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}